export const ClickToPayPaymentMethodName = "ClickToPay";
